import { Box, Button, Container, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import Color from '../../layouts/Color';

const boxMainStyle = {
  alignItems: 'center',
  display: 'flex',
  flexGrow: 1,
  minHeight: '100%'
};
const boxStyle = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  my: 10
}
const btnStyle = { 
  mt: 3, backgroundColor: Color.Main ,
  '&:hover': {background: Color.Button, color: Color.Normal}
};

const PageNotFound = () => {
  const navigate = useNavigate()
  return(
  <>
    <Box component="main" sx={boxMainStyle}>
      <Container maxWidth="md">
        <Box sx={boxStyle}>
          <Typography align="center" color="textPrimary" variant="h4">
            404: The page you are looking for isn’t here
          </Typography>
          <Typography align="center" color="textPrimary" variant="subtitle2">
            You either tried some shady route or you came here by mistake.
            Whichever it is, try using the navigation
          </Typography>
            <Button
              startIcon={(<ArrowBackIcon fontSize="small" />)}
              sx={btnStyle}
              variant="contained"
              onClick={() => {navigate('/dashboard', {replace: true})}}
            >
              Go back to homepage
            </Button>
        </Box>
      </Container>
    </Box>
  </>
  )
};

export default PageNotFound;
